import { Controller } from '../const'
import { App } from '../App'
import styles from './Navigation.module.css'

export class NavigationController implements Controller {
  private readonly links: HTMLElement[]
  private collapsed = false

  constructor(
    private readonly node: HTMLElement,
    private readonly app: App,
  ) {
    this.onOver = this.onOver.bind(this)
    this.onOut = this.onOut.bind(this)
    this.links = Array.from(this.node.querySelectorAll(`.${styles.Item}`) as NodeListOf<HTMLElement>)

    this.node.addEventListener('mouseenter', this.onOver)
    this.node.addEventListener('mouseleave', this.onOut)
  }

  onOver() {
    this.node.classList.remove(styles.Collapsed)
  }

  onOut() {
    if (this.collapsed) {
      this.node.classList.add(styles.Collapsed)
    }
  }

  scroll() {
    if (this.app.scrollY > 0 && !this.collapsed) {
      this.collapsed = true
      this.node.classList.add(styles.Collapsed)
    } else if (this.app.scrollY <= 0 && this.collapsed) {
      this.collapsed = false
      this.node.classList.remove(styles.Collapsed)
    }
  }

  dispose() {
    this.node.removeEventListener('mouseenter', this.onOver)
    this.node.removeEventListener('mouseleave', this.onOut)
  }
}
